enum ProjectSetUpPage {
  DEFAULT = 'default',

  EDIT_PROFILE = 'edit-profile',
  NOTIFICATION_SETTINGS = 'notification-settings',

  USER_DIRECTORY = '6',
  COMPANY_DIRECTORY = 'company-directory',
  USER_TAGS = 'user-tags',

  PROJECT_DETAILS = '1',
  PROJECT_CREATION = 'project-creation',
  MAP_SETUP = 'map-setup',
  PRESENTATION_MODE = '7',
  INTEGRATIONS = 'integrations',
  ANALYTICS = 'analytics',
  MATERIALS_UPLOAD = 'materials-upload',
  MATERIALS = 'materials',
  EQUIPMENT = 'equipment',
  LOCATIONS = 'locations',
  STRUXTAGS = 'struxtags',

  FORM_WORKFLOWS = 'form-workflows',
  FORM_NOTIFICATIONS = 'form-notifications',

  DELIVERY_WORKFLOWS = '8',
  DELIVERY_LOCATIONS = 'delivery-locations',
  DELIVERY_CARDS = 'delivery-cards',
  DELIVERY_NOTIFICATIONS = 'delivery-notifications',

  QR_SCANNERS_SETUP = 'qr-scanners-setup',

  TEAM_ASSIGNMENT = '11',
  APPS_CONNECTION = '12',
}

// Query-param keys for project-setup navigation (e.g. ?page=equipment&tab=controls):
// `page` selects the setup page, `tab` deep-links into a sub-tab of a resource
// setup page. Shared by the setup pages, the page store, and the resource
// pickers that navigate to them.
export const SETUP_PAGE_QUERY_KEY = 'page'
export const SETUP_TAB_QUERY_KEY = 'tab'

export default ProjectSetUpPage
